import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { ORDEREQUITYSTEPS } from 'src/constants/productConstants';
import { ADDPRODUCTMETHODS } from 'src/constants/productConstants';
import UnsavedChanges from './notifications/UnsavedChanges';
import { clearTemplateProducts, validateProducts } from 'src/pages/equity/redux/actions';
import {
    changeShippingSegmentIndex,
    reSetProgressBarStatus,
    updateCartDataShipping,
    setProgressBarStatus,
    initialEquityData,
    clearSingleDropDownList,
} from 'src/pages/equity/redux/actions';
import { useHistory } from 'react-router-dom';
import NoInventoryShippingNonTissueSet from 'src/pages/scheduleSurgery/components/surgery/notifications/NoInventoryShippingNonTissueSet';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import {
    getQuantityCount,
    isMobileDevice,
    logErrorToConsole,
    redirectToInitialPath,
} from 'src/utils/util';
import { stopTimer, getTimerData } from 'src/common/redux/timerActions';
import { formatElapsedTimeHHMMSS } from 'src/utils/timerUtils';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';
import { getEquityDetails } from 'src/pages/equity/redux/actions';
import { GETEQUITYDETAILSDATA } from 'src/constants/productConstants';
import { resetNotes } from 'src/common/redux/actions/index.js';

function EquityFooter({
    tabletPortraitMargin,
    viewTemplate,
    selectedItems,
    disabled,
    createTemplate,
    addProductMethod,
    currentActivity,
    setViewSurgerySuccess,
    saveEquityAndExit,
    showSubmit,
    showNext,
    nonTissueSetsForInventoryShipping,
    productSearchPagination,
    justifyContent,
    children,
    customStyle = {
        position: 'fixed',
        width: { standard: 'calc(100% - 5rem)', smallDevice: '100%' },
        padding: '5px',
        inPaddingVertical: '5px',
    },
    count = 0,
    updateCartDataAfterPriceOverride = () => { },
    cancelCreateTemplate = () => { },
    discardPriceOverrideTable = () => { },
    isValidProductsItems = () => true,
    resetContactNumberMethod,
    isValidContactNumber,
    func,
    setSelectedAddProductMethod,
    setIsPriceOverride,
    isOverrideChange,
    tissuePO,
    nonTissuePO,
    checkPoNumberTissue,
    checkPoNumberNonTissue,
    checkPoNumber,
    setIsSubmitClicked,
    setPriceUpdated,
    callCreateTemplate = () => { },
    //nonTissuePO,
    myCaseRef
}) {
    //const classes = useStyles();
    const { t: translation } = useTranslation();
    const dispatch = useDispatch();
    const [cancel, setCancel] = useState(false);
    const [overrideCancel, setOverrideCancel] = useState(false);
    // const [saveAndExit, setsaveAndExit] = useState(false);
    const history = useHistory();
    const [onlyNonTissueSets, setOnlyNonTissueSets] = useState(false);
    const timerData = useSelector((state) => getTimerData(state));
    const { currentSelectedIndex, equityDetails, isLanguageChanged } =
        useSelector((state) => ({
            currentSelectedIndex: state.equityReducer.selectedShippingSegment,
            inventoryShipping:
                state.surgeryReducer.surgeryDetails.inventoryShipping,
            surgeryDateTime:
                state.surgeryReducer.surgeryDetails.surgeryDateTime,
            equityDetails: state.equityDetailsReducer.equityDetails,
            orderList: state.ordersListReducer.orderList,
            isLanguageChanged: state.loginReducer.isLanguageChanged,
        }));

    const { visualInspectionAcknowledgement } = useSelector((state) => ({
        visualInspectionAcknowledgement:
            state.surgeryReducer.visualInspectionAcknowledgement,
    }));

    useEffectWithErrorLogging(() => { }, [visualInspectionAcknowledgement]);

    // product validation
    const validateProductsQuickOrder = (products) => {
        const productsToBeAdded = products.filter(
            (product) => product.materialType !== 'ZKMT'
        );
        const bundleProductsToBeAdded = products.filter(
            (product) => product.materialType === 'ZKMT'
        );
        const filteredProducts = productsToBeAdded.filter(
            (product) => product.quantity > 0
        );
        const filteredBundleProducts = bundleProductsToBeAdded.filter(
            (product) =>
                product.quantity > 0 &&
                product.children &&
                product.children.length > 0
        );
        return [...filteredProducts, ...filteredBundleProducts];
    };

    const handleDiscardChanges = () => {
        sessionStorage.removeItem('myCaseRefID');
        const redirectPath = redirectToInitialPath(history);
        // dispatch(resetEquityDetails());
        dispatch(reSetProgressBarStatus());
        dispatch(resetNotes());
        dispatch(
            clearSingleDropDownList({
                name: 'territories',
            })
        );
        // dispatch(resetCartData());
        history.push(redirectPath);
    };

    const handleOverrideDiscardChanges = () => {
        setSelectedAddProductMethod(null);
        setIsPriceOverride(false);
        setOverrideCancel(!overrideCancel);
        discardPriceOverrideTable();
    };

    const getButtonsBasedOnActivity = (
        viewTemplate,
        selectedItems,
        disabled,
        createTemplate,
        addProductMethod,
        productSearchPagination,
    ) => {
        if (productSearchPagination) {
            return children;
        } else if (viewTemplate) {
            return (
                <Button
                 id={'equity-equityfooter-addselectedtocart-button'}
                    show={true}
                    variant={count > 0 ? ButtonStyles.primary : ButtonStyles.disabled}
                    // primary={count > 0}
                    disabled={count === 0}
                    width={'210px'}
                    margin={
                        isMobileDevice()
                            ? '0px 0px 4px 0px'
                            : customStyle.inPaddingVertical
                    }
                    mobileWidth={'284px'}
                    height={'38px'}
                    clicked={() => {
                        try {
                            if (count > 0) {
                                isValidProductsItems();
                            }
                            dispatch(clearTemplateProducts());
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    //margin={customStyle.inPaddingVertical}
                    fontSize={'13px'}
                >
                    {translation('equity.equityFooter.addSelectedToCartButton')}{' '}
                    ({count})
                </Button>
            );
        } else if (addProductMethod === 'Price Override') {
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent:
                            window.innerWidth <= sizes.mobileDevice
                                ? 'space-evenly'
                                : 'initial',
                        padding:
                            window.innerWidth <= sizes.mobileDevice
                                ? '0.4375rem 0 0.0625rem 0'
                                : '9px 0',
                        width:
                            window.innerWidth <= sizes.mobileDevice
                                ? '100%'
                                : '',
                    }}
                >
                    <Button
                     id={'equity-equityfooter-cancel-button'}
                        show={true}
                        variant={ButtonStyles?.secondary}
                        //secondary={true}
                        width={
                            window.innerWidth <= sizes.mobileDevice
                                ? '40%'
                                : '140px'
                        }
                        borderRadius={isMobileDevice() ? '19px' : '25px'}
                        height={'38px'}
                        clicked={() => {
                            setOverrideCancel(!overrideCancel);
                        }}
                        cancel={true}
                        margin={
                            isMobileDevice()
                                ? '0px 5px 4px 0px'
                                : '0px 6px 0px 0px'
                        }
                    >
                        {translation('equity.equityFooter.cancelButton')}
                    </Button>
                    <Button
                     id={'equity-equityfooter-apply-button'}
                        show={true}
                        variant={isOverrideChange ? ButtonStyles.primary : ButtonStyles.disabled}
                        disabled={!isOverrideChange}
                        width={
                            window.innerWidth <= sizes.mobileDevice
                                ? '40%'
                                : '140px'
                        }
                        borderRadius={isMobileDevice() ? '19px' : '25px'}
                        height={'38px'}
                        clicked={() => {
                            try {
                                updateCartDataAfterPriceOverride();
                                setSelectedAddProductMethod(null);
                                setIsPriceOverride(false);
                                setPriceUpdated(true);
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                        //margin={'5px'}
                      //  primary={isOverrideChange}
                        margin={
                            window.innerWidth <= sizes.mobileDevice
                                ? '0px 0px 4px 0px'
                                : '0px -8% 0px 0px'
                        }
                    >
                        {translation('equity.equityFooter.applyButton')}
                        {/* {isMobileDevice()
                            ? translation('equity.equityFooter.applyButton')
                            : translation('equity.equityFooter.saveButton')} */}
                    </Button>
                </div>
            );
        } else if (createTemplate) {
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent:
                            window.innerWidth <= sizes.mobileDevice
                                ? 'space-evenly'
                                : 'flex-end',
                        padding:
                            window.innerWidth <= sizes.mobileDevice
                                ? '1.125rem 1rem'
                                : '11px 0',
                        width:
                            window.innerWidth <= sizes.mobileDevice
                                ? '100%'
                                : '',
                        marginRight:
                            window.innerWidth <= sizes.mobileDevice
                                ? ''
                                : '0px',
                    }}
                >
                    <Button
                     id={'equity-equityfooter-cancelmobile-button'}
                        show={true}
                        variant={ButtonStyles?.secondary}
                      //  secondary={true}
                        width={
                            window.innerWidth <= sizes.mobileDevice
                                ? '40%'
                                : '122px'
                        }
                        height={'38px'}
                        clicked={cancelCreateTemplate}
                        //margin={'5px'}
                        fontSize={'13px'}
                        margin={
                            isMobileDevice()
                                ? '0px 0px 4px 0px'
                                : '0px 6px 0px 0px'
                        }
                    >
                        {translation('equity.equityFooter.cancelButton')}
                    </Button>
                    <Button
                     id={'equity-equityfooter-save-button'}
                        show={true}
                        variant={selectedItems ? ButtonStyles.primary : ButtonStyles.disabled}
                        disabled={!selectedItems}
                        width={
                            window.innerWidth <= sizes.mobileDevice
                                ? '40%'
                                : '122px'
                        }
                        height={'38px'}
                        clicked={callCreateTemplate}
                        //margin={'5px'}
                        fontSize={'13px'}
                       // primary={selectedItems && selectedItems.length}
                        margin={
                            isMobileDevice()
                                ? '0px 0px 4px 0px'
                                : '0px 10px 0px 0px'
                        }
                    >
                        {translation('equity.equityFooter.saveButton')}
                    </Button>
                </div>
            );
        } else if (addProductMethod === ADDPRODUCTMETHODS()[2].name) {
            return (
                <div style={{ display: 'inline-block' }}>
                    <Button
                     id={'equity-equityfooter-addtocart-button'}
                        show={true}
                        variant={getQuantityCount(selectedItems) > 0 ? ButtonStyles.primary : ButtonStyles.disabled}
                        // primary={getQuantityCount(selectedItems) > 0}
                        disabled={getQuantityCount(selectedItems) === 0}
                        width={
                            isLanguageChanged && selectedItems.length > 0
                                ? '197px'
                                : '178px'
                        }
                        mobileWidth={'289px'}
                        height={'38px'}
                        clicked={() => {
                            try {
                                dispatch(
                                    validateProducts({
                                        products:
                                            validateProductsQuickOrder(
                                                selectedItems
                                            ),
                                        orderType: 'ZOR',
                                    })
                                );
                                func();
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                            // setSelectedAddProductMethod(null)
                            // setTimeout(
                            //     () => setProductsToBeAddedToCart([]),
                            //     1800
                            // );
                        }}
                        margin={'5px'}
                       
                    >
                        <div style={{ paddingRight: '4px' }}>
                            {translation('equity.equityFooter.addtocart')}
                        </div>
                        {selectedItems.length > 0 && (
                            <div>{`(${getQuantityCount(selectedItems)})`}</div>
                        )}
                    </Button>
                </div>
            );
        }
        else if (addProductMethod === ADDPRODUCTMETHODS()[4].name) {
            return (
                <div style={{ display: 'inline-block' }}>
                    <Button
                     id={'equity-equityfooter-addtocartmobile-button'}
                        show={true}
                        variant={getQuantityCount(selectedItems) > 0 ? ButtonStyles.primary : ButtonStyles.disabled}
                        // primary={getQuantityCount(selectedItems) > 0}
                        disabled={getQuantityCount(selectedItems) === 0}
                        width={
                            isLanguageChanged && selectedItems.length > 0
                                ? '197px'
                                : '178px'
                        }
                        mobileWidth={'289px'}
                        height={'38px'}
                        clicked={() => {
                            try {
                                dispatch(
                                    validateProducts({
                                        products:
                                            validateProductsQuickOrder(
                                                selectedItems
                                            ),
                                        orderType: 'ZOR',
                                    })
                                );
                                func();
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                            // setSelectedAddProductMethod(null)
                            // setTimeout(
                            //     () => setProductsToBeAddedToCart([]),
                            //     1800
                            // );
                        }}
                        margin={'5px'}
                       
                    >
                        <div style={{ paddingRight: '4px' }}>
                            {translation('equity.equityFooter.addtocart')}
                        </div>
                        {selectedItems.length > 0 && (
                            <div>{`(${getQuantityCount(selectedItems)})`}</div>
                        )}
                    </Button>
                </div>
            );
        }
        else {
            return (
                <>
                    {' '}
                    <Button
                     id={'equity-equityfooter-cancelmobile-button'}
                        show={true}
                        // secondary={true}
                        width={isLanguageChanged ? '110px' : '95px'}
                        height={'38px'}
                        margin={'5px'}
                        variant={ButtonStyles?.cancel}
                        //cancel={true}
                        clicked={() => setCancel(!cancel)}
                    >
                        {translation('equity.equityFooter.cancelButton')}
                    </Button>
                    <Button
                     id={'equity-equityfooter-saveandexit-button'}
                        show={true}
                        variant={(currentActivity === ORDEREQUITYSTEPS[3] || currentActivity === ORDEREQUITYSTEPS[1] || !disabled) ? ButtonStyles.secondary : ButtonStyles.disabled}
                        // secondary={
                        //     currentActivity === ORDEREQUITYSTEPS[3]
                        //         ? true
                        //         : currentActivity === ORDEREQUITYSTEPS[1]
                        //             ? true
                        //             : !disabled
                        // }
                        width={'95px'}
                        height={'38px'}
                        margin={'5px'}
                        // clicked={() => setsaveAndExit(!saveAndExit)}
                        clicked={!disabled && saveEquityAndExit}
                        disabled={
                            currentActivity === ORDEREQUITYSTEPS[0]
                                ? disabled
                                : false
                        }
                    >
                        <div style={{ whiteSpace: 'nowrap' }}>
                            {translation(
                                'equity.equityFooter.saveAndExitButton'
                            )}
                        </div>
                    </Button>
                    {showNext &&
                        (!tissuePO ||
                            !nonTissuePO ||
                            currentSelectedIndex === 0 ||
                            disabled) ? (
                        <>
                            <Button
                             id={'equity-equityfooter-next-button'}
                                show={true}
                                variant={ButtonStyles?.primary}
                                //primary={true}
                                width={'95px'}
                                height={'38px'}
                                margin={'5px'}
                                // clicked={() => setsaveAndExit(!saveAndExit)}
                                clicked={() => {
                                    try {
                                        if (currentSelectedIndex === 0) {
                                            checkPoNumberNonTissue();
                                            if (nonTissuePO) {
                                                dispatch(
                                                    changeShippingSegmentIndex(
                                                        currentSelectedIndex ===
                                                            0
                                                            ? 1
                                                            : 0
                                                    )
                                                );
                                            }
                                        }
                                        else if (currentSelectedIndex === 1) {
                                            checkPoNumberTissue();
                                            if (tissuePO) {
                                                dispatch(
                                                    changeShippingSegmentIndex(
                                                        currentSelectedIndex ===
                                                            1
                                                            ? 0
                                                            : 1
                                                    )
                                                );
                                            }
                                        }
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                            >
                                {translation('equity.equityFooter.nextButton')}
                            </Button>
                        </>
                    ) : (
                        <>
                            {!showSubmit ? (
                                <Button
                                 id={'equity-equityfooter-continue-button'}
                                    show={true}
                                    variant={disabled ? ButtonStyles?.surgeryNotesDisabled : ButtonStyles.primary}
                                   // surgeryNotesDisabled={true}
                                    //primary={!disabled}
                                    width={'95px'}
                                    height={'38px'}
                                    clicked={() => {
                                        try {
                                            if (
                                                currentActivity ===
                                                ORDEREQUITYSTEPS[2]
                                            ) {
                                                checkPoNumber();
                                                if (tissuePO && nonTissuePO) {
                                                    dispatch(
                                                        setProgressBarStatus(
                                                            currentActivity
                                                        )
                                                    );
                                                    // dispatch(
                                                    //     setOrderSummaryModalState({
                                                    //         myCaseRef: myCaseRef,
                                                    //         orderSummaryModal: false,
                                                    //     })
                                                    // );
                                                    if (
                                                        currentActivity ===
                                                        ORDEREQUITYSTEPS[3]
                                                    ) {
                                                        setViewSurgerySuccess(
                                                            true
                                                        );
                                                        return;
                                                    }

                                                    if (
                                                        !nonTissueSetsForInventoryShipping.nonInventoryShipping &&
                                                        currentActivity ===
                                                            ORDEREQUITYSTEPS[2] &&
                                                        nonTissueSetsForInventoryShipping
                                                            .setsList.length > 0
                                                    )
                                                        dispatch(
                                                            updateCartDataShipping(
                                                                {
                                                                    shippingRequirement:
                                                                        nonTissueSetsForInventoryShipping.nonInventoryShipping,
                                                                },
                                                                nonTissueSetsForInventoryShipping.setsList.map(
                                                                    (set) =>
                                                                        set.productKey
                                                                )
                                                            )
                                                        );
                                                }
                                            } else {
                                                if (isValidContactNumber) {
                                                    resetContactNumberMethod();
                                                } else {
                                                    if (!disabled) {
                                                        dispatch(
                                                            setProgressBarStatus(
                                                                currentActivity
                                                            )
                                                        );
                                                        if (
                                                            currentActivity ===
                                                            ORDEREQUITYSTEPS[3]
                                                        ) {
                                                            setViewSurgerySuccess(
                                                                true
                                                            );
                                                            return;
                                                        }

                                                        if (
                                                            !nonTissueSetsForInventoryShipping.nonInventoryShipping &&
                                                            currentActivity ===
                                                                ORDEREQUITYSTEPS[2] &&
                                                            nonTissueSetsForInventoryShipping
                                                                .setsList
                                                                .length > 0
                                                        )
                                                            dispatch(
                                                                updateCartDataShipping(
                                                                    {
                                                                        shippingRequirement:
                                                                            nonTissueSetsForInventoryShipping.nonInventoryShipping,
                                                                    },
                                                                    nonTissueSetsForInventoryShipping.setsList.map(
                                                                        (set) =>
                                                                            set.productKey
                                                                    )
                                                                )
                                                            );
                                                    }
                                                }
                                            }

                                            if (
                                                currentActivity ===
                                                ORDEREQUITYSTEPS[0]
                                            ) {
                                                // dispatch(
                                                //     storeEquityReference(
                                                //         equityDetails.myCaseRef
                                                //     )
                                                // );
                                                dispatch(initialEquityData());

                                                // !myCaseRef ||
                                                // orderList.filter(
                                                //     (item) =>
                                                //         item.myCaseRef ==
                                                //         equityDetails.myCaseRef
                                                // ).length >= 1 ||
                                                // !equityDetails.myCaseRef
                                                !myCaseRef &&
                                                !equityDetails.myCaseRef
                                                    ? dispatch(
                                                          getEquityDetails(
                                                              GETEQUITYDETAILSDATA
                                                          )
                                                      )
                                                    : null;
                                            }
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                    disabled={disabled}
                                    margin={'5px'}
                                    fontSize={'15px'}
                                >
                                    {translation(
                                        'equity.equityFooter.continueButton'
                                    )}
                                </Button>
                            ) : (
                                <Button
                                 id={'equity-equityfooter-submit-button'}
                                    show={true}
                                    variant={disabled ? ButtonStyles?.surgeryNotesDisabled : ButtonStyles.surgery}
                                   // surgeryNotesDisabled={true}
                                    width={'95px'}
                                    height={'38px'}
                                    clicked={() => {
                                        try {
                                            if (!disabled) {
                                                dispatch(stopTimer());
                                                setIsSubmitClicked(true);
                                                // dispatch(
                                                //     setProgressBarStatus(
                                                //         currentActivity
                                                //     )
                                                // );
                                                /*if (
                                                currentActivity ===
                                                ORDEREQUITYSTEPS[0]
                                            ) {
                                                dispatch(
                                                    storeEquityReference(
                                                        equityDetails.myCaseRef
                                                    )
                                                );
                                                if (
                                                    new Date(
                                                        new Date(
                                                            surgeryDateTime
                                                        ).setHours(0, 0, 0, 0)
                                                    ).getTime() ===
                                                    new Date().setHours(
                                                        0,
                                                        0,
                                                        0,
                                                        0
                                                    )
                                                ) {
                                                    dispatch(
                                                        currentSurgeryDateSelected(
                                                            true
                                                        )
                                                    );
                                                } else {
                                                    dispatch(
                                                        currentSurgeryDateSelected(
                                                            false
                                                        )
                                                    );
                                                }
                                            }*/
                                                if (
                                                    currentActivity ===
                                                    ORDEREQUITYSTEPS[3]
                                                ) {
                                                    setViewSurgerySuccess(true);
                                                    return;
                                                }
                                            }
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                    surgery={!disabled}
                                    disabled={disabled}
                                    margin={'5px'}
                                >
                                    {translation(
                                        'equity.equityFooter.submitButton'
                                    )}
                                </Button>
                            )}
                        </>
                    )}
                </>
            );
        }
    };
    return (
        <>
            <BottomNavigation
                justifyContent="space-around"
                moblieJustifyContent="space-evenly"
                padding={customStyle.padding}
                right={'0'}
                position={customStyle.position}
                zIndex={'2'}
                width={customStyle.width}
            >
                {
                    <BottomNavigationButtonContainer
                        smallJustifyContent={'center'}
                        justifyContent={justifyContent}
                        tabletPortraitMargin={tabletPortraitMargin}
                    >
                        {getButtonsBasedOnActivity(
                            viewTemplate,
                            selectedItems,
                            disabled,
                            createTemplate,
                            addProductMethod,
                            productSearchPagination
                        )}
                    </BottomNavigationButtonContainer>
                }
            </BottomNavigation>
            {cancel ? (
                <UnsavedChanges
                    onDiscard={() => {
                        try {
                            handleDiscardChanges();
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    onClose={() => setCancel(!cancel)}
                />
            ) : null}
            {/*Price Override Footer*/}
            {overrideCancel ? (
                <UnsavedChanges
                    onDiscard={() => {
                        try {
                            handleOverrideDiscardChanges();
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    onClose={() => setOverrideCancel(!overrideCancel)}
                    fromPriceOverride={true}
                />
            ) : null}
            {/* Only non-tissue sets can be added */}
            {onlyNonTissueSets && (
                <NoInventoryShippingNonTissueSet
                    onClose={() => setOnlyNonTissueSets(false)}
                />
            )}
        </>
    );
}

// const useStyles = makeStyles((theme) => ({

//     bottomNavButton: {
//         height:'60px',
//         overflow:'hidden',
//         bottom:'0'
//     },
// }));

EquityFooter.propTypes = {
    tabletPortraitMargin: PropTypes.any,
    viewTemplate: PropTypes.bool,
    selectedItems: PropTypes.array,
    disabled: PropTypes.bool,
    createTemplate: PropTypes.bool,
    addProductMethod: PropTypes.func,
    currentActivity: PropTypes.string,
    setViewSurgerySuccess: PropTypes.func,
    saveSurgeryAndExit: PropTypes.func,
    showSubmit: PropTypes.bool,
    showNext: PropTypes.bool,
    nonTissueSetsForInventoryShipping: PropTypes.array,
    productSearchPagination: PropTypes.bool,
    justifyContent: PropTypes.string,
    children: PropTypes.element,
    zIndex: PropTypes.number,
    customStyle: PropTypes.object,
    count: PropTypes.number,
    callCreateTemplate: PropTypes.func,
    cancelCreateTemplate: PropTypes.func,
    isValidProductsItems: PropTypes.func,
};

export default EquityFooter;

const BottomNavigationButtonContainer = styled.div`
    display: flex;
    width: 100%;
    max-width: 1096px;
    flex-direction: row;
    justify-content: ${(props) =>
        props.justifyContent ? props.justifyContent : 'flex-end'};

    margin-right: 15px;

    @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: landscape) {
        margin-right: 45px;
    }

    @media only screen and (max-device-width: 1024px) and (min-device-width: 768px) and (orientation: landscape) {
        /* For ipad landscape layouts only */
        margin-right: 45px;
    }
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        /* For portrait layouts only */
        justify-content: ${({ smallJustifyContent }) =>
        smallJustifyContent ? smallJustifyContent : 'center'};
        margin: ${(props) =>
        props.tabletPortraitMargin ? props.tabletPortraitMargin : ''};
    }

    //ipad Pro(10.5 inch) landscape
    @media only screen and (min-device-width: 1112px) and (max-device-width: 1112px) and (orientation: landscape) and (-webkit-max-device-pixel-ratio: 2) {
        margin-right: 20px;
    }

    ${media.mobileDevice`
        justify-content: space-evenly;
    `}
`;
